import classNames from 'classnames'
import { useState } from 'react'
import { Button } from 'shared/ui/Button'
import { Divider } from 'shared/ui/Divider/Divider'
import { makeTextFieldAutoFocus, TextField } from 'shared/ui/TextField'
import { MAX_CRM_LENGTH } from 'shared/constants/auth'
import { CRMS, CrmEnum, type ICrm } from 'entities/Integrations/lib/crm'

import styles from './styles.module.scss'

type IDropdownCrmContentProps = {
  value: ICrm | null
  onChange: (crm: ICrm | null) => void
  onClose: () => void
}

export const DropdownCrmContent = ({ value, onChange, onClose }: IDropdownCrmContentProps) => {
  const [customCrmView, setCustomCrmView] = useState(value?.id === CrmEnum.other)
  const [customCrm, setCustomCrm] = useState(value?.id === CrmEnum.other ? value.name : '')

  const handleCustomCrm = (next: string) => {
    if (next.length > MAX_CRM_LENGTH) return
    setCustomCrm(next)
  }

  const handleBack = () => setCustomCrmView(false)

  const handleConfirm = () => {
    const trimmedName = customCrm.trim()
    if (!trimmedName) return
    onChange({ id: CrmEnum.other, name: trimmedName, value: 'Other', icon: 'lightning2' })
    onClose()
  }

  if (customCrmView) {
    return (
      <div className={styles.wrap}>
        <Button
          className={styles.backButton}
          icon={'chevronLeft'}
          typeBtn='menuItem'
          type='button'
          onClick={handleBack}
          text={'Other'}
        />
        <Divider className={styles.divider} />
        <TextField
          className={classNames(styles.textField, styles.dropdown)}
          variant='integrated'
          size='medium'
          InputProps={{ placeholder: 'Enter CRM name' }}
          onChange={handleCustomCrm}
          value={customCrm}
          mainActions={[makeTextFieldAutoFocus({ withFocus: true })]}
        />
        <div className={styles.dropdownFooter}>
          <Button
            className={styles.confirmButton}
            typeBtn='contained'
            type='button'
            onClick={handleConfirm}
            disabled={!customCrm.trim().length || !(customCrm.length <= MAX_CRM_LENGTH)}
            text={'Confirm'}
            contained={'primary'}
            fullWidth
          />
        </div>
      </div>
    )
  }

  return (
    <div className={classNames(styles.wrap, styles.list)}>
      {CRMS.map((item) => (
        <Button
          key={item.id}
          className={styles.selectItem}
          typeBtn='menuItem'
          type='button'
          icon={item.icon}
          onClick={() => {
            if (item.id !== CrmEnum.other) {
              onChange(item)
              onClose()
              return
            }
            setCustomCrmView(true)
          }}
          iconRightProps={
            item.id === value?.id
              ? {
                  color: 'var(--content-brand-primary)',
                  className: styles.selectCrmIcon,
                  icon: 'check1',
                }
              : undefined
          }
          text={item.name}
          fullWidth
        />
      ))}
    </div>
  )
}
